// extracted by mini-css-extract-plugin
module.exports = {"error":"style-module--error--2Wz1c","blink":"style-module--blink--Ar_1j"};